export default "__VITE_ASSET__CZDu0AqP__"